import { axiosHttp } from "@/util/axios.js";




// 添加地址
export function addShopAddress(data){
  return axiosHttp.$postAxios('/addAddress', data)
}

// 查询地址
export function searchShopAddress(){
  return axiosHttp.$getAxios('/getAddress')
}

// 修改地址
export function updateShopAddress(data){
  return axiosHttp.$postAxios('/updateAddress', data)
}

// 删除地址
export function deleteShopAddress(data){
  return axiosHttp.$postAxios('/deleteAddress', data)
}


// WEBPACK FOOTER //
// ./src/apis/address/address.js